module.exports = __webpack_public_path__ + "static/media/icon-payment.5fb95af5.svg";